import React from "react";
import Logo from "../../ui/layout/page/header/logo";
import "../../ui/layout/page/header/styles.scss";
import GridMainLayout from "../../ui/widgets/grid";
import GridItem from "../../ui/layout/page/grid-item";

const classNameBase = "scd-page-header";

export default function ErrorHeader(): React.JSX.Element {
  return (
    <>
      <header className={`${classNameBase} ${classNameBase}-wrapper`}>
        <GridMainLayout container={true} spacing={5}>
          <GridItem>
            <Logo />
          </GridItem>
        </GridMainLayout>
      </header>
    </>
  );
}
